var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ErrorType } from "../types/ErrorType";
import { readServerErrors } from "./serverErrorUtils";
/** HTTP status mod-br-publishers answers when a publisher user acts on another publisher (RECEK-76282). */
var FORBIDDEN_STATUS = 403;
/** Translation of the refusal of another publisher than the user's own one. */
export var FOREIGN_PUBLISHER_MESSAGE_ID = "ui-br-publishers.publishers.error.foreignPublisher";
/**
 * A failed publisher action (close, closing, data confirmation) carrying the translation id of the message the user
 * should see, so the page shows a Czech error instead of failing silently.
 *
 * Never test it with `instanceof`: the Stripes build transpiles `class extends Error` to ES5, where the instance loses
 * the subclass prototype (RECEK-76282 X1) - use {@link isPublisherActionError}, which checks the discriminator.
 */
var PublisherActionError = /** @class */ (function (_super) {
    __extends(PublisherActionError, _super);
    function PublisherActionError(messageId, cause) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, messageId) || this;
        _this.isPublisherActionError = true;
        // restores the prototype the ES5 transpilation of `extends Error` loses (the guard does not depend on it)
        Object.setPrototypeOf(_this, _newTarget.prototype);
        _this.name = "PublisherActionError";
        _this.messageId = messageId;
        _this.cause = cause;
        return _this;
    }
    return PublisherActionError;
}(Error));
export { PublisherActionError };
/**
 * Whether the error is a {@link PublisherActionError} - by its discriminator, not by its prototype.
 *
 * @param error the caught error
 */
export var isPublisherActionError = function (error) {
    return typeof error === "object" &&
        error !== null &&
        error.isPublisherActionError ===
            true &&
        typeof error.messageId === "string";
};
/**
 * Whether the backend refused the request because the publisher is not the user's own one (HTTP 403, error type
 * "-6"). The backend answers 403, never 401: a 401 would make Stripes treat the session as expired.
 *
 * @param error the error thrown by the ky client
 */
export var isForeignPublisherError = function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var status;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                status = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status;
                if (status !== FORBIDDEN_STATUS)
                    return [2 /*return*/, false];
                return [4 /*yield*/, readServerErrors(error)];
            case 1: return [2 /*return*/, (_b.sent()).some(function (item) { return item.type === ErrorType.PUBLISHER_CANNOT_UPDATE_ANOTHER_PUBLISHER; })];
        }
    });
}); };
/**
 * Wraps a failed publisher action: the refusal of another publisher gets its own message, any other failure the
 * action's failure message.
 *
 * @param error the error thrown by the ky client
 * @param failureMessageId translation id of the action's generic failure
 */
export var toPublisherActionError = function (error, failureMessageId) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = PublisherActionError.bind;
                return [4 /*yield*/, isForeignPublisherError(error)];
            case 1: return [2 /*return*/, new (_a.apply(PublisherActionError, [void 0, (_b.sent())
                        ? FOREIGN_PUBLISHER_MESSAGE_ID
                        : failureMessageId,
                    error]))()];
        }
    });
}); };
/**
 * The translation id of the message for a failed publisher action.
 *
 * @param error the caught error
 * @param fallbackMessageId used when the error is not a {@link PublisherActionError}
 */
export var publisherActionMessageId = function (error, fallbackMessageId) {
    return isPublisherActionError(error) ? error.messageId : fallbackMessageId;
};
